import { RealEstateSiteRecommendedUseTypes, SiteRecommendedUseTypesLanguages } from '../../@types/types'

export const siteRecommendedUseTypesLanguages: SiteRecommendedUseTypesLanguages = {
  noInformation: 'no information',
  futureDevelopmentLand: 'future development land',
  twinHouse: 'twin house',
  singleFamilyHouse: 'single Family House',
  garage: 'garage',
  garden: 'garden',
  noDevelopment: 'no Development',
  apartmentBuilding: 'apartment Building',
  orchard: 'orchard',
  terraceHouse: 'terrace House',
  parkingSpace: 'parking Space',
  villa: 'villa',
  forrest: 'forrest',
  littleStore: 'little Store',
  gastronomy: 'gastronomy',
  business: 'business',
  hotel: 'hotel',
  industry: 'industry',
  smallBusiness: 'small Business',
  stock: 'stock',
  carPark: 'car Park',
  production: 'production',
}

export const realEstateSiteRecommendedUseTypesWithTranslationKeys = Object.entries(
  RealEstateSiteRecommendedUseTypes
).map((type) => ({
  translationKey: type[0],
  property: type[1],
}))

export const getRealEstateSiteRecommendedUseTypes = (recommendedUseTypes: RealEstateSiteRecommendedUseTypes[]) => {
  const newResult: { translationKey: string; property: RealEstateSiteRecommendedUseTypes }[] = []
  recommendedUseTypes.forEach((type) => {
    newResult.push(
      realEstateSiteRecommendedUseTypesWithTranslationKeys.filter((element) => element.property === type)[0]
    )
  })
  return newResult
}
